import { CoreIcon } from '../core-icon';
import errorCircleFillSVG from '../../../src/images/icons/error-circle-fill.svg';

export const ErrorCircleFillIcon = props => {
  return <CoreIcon src={errorCircleFillSVG} {...props} />;
};
